export const dialogContentSx = {
  px: 2,
  my: 2
};

export const patientHeaderRowSx = {
  display: 'flex',
  justifyContent: 'space-between'
};

export const responseSectionSx = {
  mt: 1.5
};

export const closeIconSx = {
  fontSize: 22
};

export const completedTimelineIconSx = {
  color: '#4CAF50'
};

const statusStyles = {
  Completed: {
    color: '#4CAF50',
    border: '#4CAF50'
  },

  'Not Acknowledged': {
    color: '#2196F3',
    border: '#2196F3'
  },

  'Awaiting Clinic': {
    color: '#F44336',
    border: '#F44336'
  }
};

export const getStatusStyle = status =>
  statusStyles[status] ||
  statusStyles['Not Acknowledged'];

export const statusChipSx = chipStyle => ({
  color: chipStyle.color,
  bgcolor: 'transparent',
  border: `1px solid ${chipStyle.border}`,
  fontSize: 11,
  fontWeight: 500,
  borderRadius: 25,

  '& .MuiChip-label': {
    px: 1.5,
    py: 0
  }
});